<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToHeader'
});
</script>
<template>
	<div ref="elRef" :flex="flex ? flex : null" class="to-header" :class="setClass" @click="emit('click')">
		<div v-if="slots.left || (Boolean(hasBack) && props.position === 'center')" class="to-header-left">
			<div v-if="hasBack" class="to-header-back" @click="emit('back')">
				<div class="to-header-back-icon"></div>
			</div>
			<slot name="left" />
		</div>

		<div v-if="props.position === 'center'" class="to-header-center">
			<div v-if="props.title" class="to-header-title-text">{{ props.title }}</div>
			<div v-if="slots.title" class="to-header-title-text">
				<slot v-if="slots.title" name="title" />
			</div>
		</div>

		<div v-else class="to-header-title">
			<div v-if="hasBack" class="to-header-back" @click="emit('back')">
				<div class="to-header-back-icon"></div>
				<div v-if="slots.icon" class="to-header-icon">
					<slot name="icon" />
				</div>
				<div v-if="props.title" class="to-header-title-text">{{ props.title }}</div>
				<div v-if="slots.title" class="to-header-title-text">
					<slot v-if="slots.title" name="title" />
				</div>
			</div>
			<template v-else>
				<div v-if="slots.icon || hasIcon" class="to-header-icon">
					<slot name="icon" />
				</div>
				<div v-if="props.title" class="to-header-title-text">{{ props.title }}</div>
				<div v-if="slots.title" class="to-header-title-text">
					<slot v-if="slots.title" name="title" />
				</div>
			</template>
			<div v-if="slots.tip" class="to-header-tip">
				<slot name="tip" />
			</div>
		</div>

		<div v-if="slots.content" class="to-header-content">
			<slot name="content" />
		</div>

		<div v-if="slots.default" class="to-header-fn">
			<slot />
		</div>

		<div v-if="slots.floatFn" class="to-header-fn is-float">
			<to-icon ref="floatFnIcon" link value="menu" mode="none" @click="toggleFloat" />
			<to-float ref="float" align="right" class="to-header-floatFn" :width="10">
				<slot name="floatFn" />
			</to-float>
		</div>

		<div v-if="slots.right" class="to-header-right">
			<slot name="right" />
		</div>
	</div>
</template>

<script lang="ts" setup>
import { ref, computed, useSlots, onMounted, getCurrentInstance } from 'vue'
import { ToIcon, ToFloat } from '@touchvue/components'

const instance = getCurrentInstance()

const elRef = ref<HTMLElement | null>(null)
const iconWidth = ref(0)

onMounted(() => {
	iconWidth.value = parseFloat(getComputedStyle(elRef.value).getPropertyValue('--icon-width'))
})

const hasIcon = computed(() => {
	return Boolean(iconWidth.value)
})


export interface Props {
	flex?: boolean
	title?: string
	color?: string
	mode?: string
	link?: boolean
	position?: 'left' | 'center'
}

const props = withDefaults(defineProps<Props>(), {
	flex: false,
	title: '',
	color: '',
	mode: 'default',
	position: 'left',
	link: false
})

const emit = defineEmits<{
	(e: 'back'): void
	(e: 'click'): void
}>()

const slots = useSlots()

const float = ref()
const floatFnIcon = ref()

const hasBack = computed(() => {
	return !!instance?.vnode.props?.onBack
})

const setClass = computed(() => {
	const arr: string[] = []

	if (props.mode) {
		arr.push(`mode-${props.mode}`)
	}

	if (props.link) {
		arr.push(`is-link`)
	}

	if (props.position) {
		arr.push(`position-${props.position}`)
	}

	return arr
})
const toggleFloat = () => {
	float.value?.toggle?.(floatFnIcon.value)
}
</script>
